module.exports = __webpack_public_path__ + "img/avatar.ad24a938.png";